import SDK from './sdk'

window.TerraOptimize = new SDK()
